"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DropdownMenu = void 0;
var react_1 = __importDefault(require("react"));
var domEvents_1 = require("../../mixins/domEvents");
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
exports.DropdownMenu = domEvents_1.focuseable(function (props) {
    var _a = props.as, as = _a === void 0 ? 'select' : _a, children = props.children, className = props.className, rest = __rest(props, ["as", "children", "className"]);
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as, className: ['dropdown-menu', className] }, rest), children));
});
//# sourceMappingURL=DropdownMenu.js.map